import { FC } from 'react';
import { Typography } from '@mui/material';
import Panel from '../../elements/Panel/Panel';

const NotificationSettingsHeader: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Panel p={2}>
      <Typography color='primary.main' variant='h6' component='h4'>
        Notification Settings
      </Typography>
      <Typography
        color='text.primary'
        variant='body1'
        sx={{ wordBreak: 'break-word' }}>
        Manage your OX Security and personal notification settings.
      </Typography>
    </Panel>
  );
};

export default NotificationSettingsHeader;
